document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-sc-back-in-stock]')) return;
  if (typeof window.BIS?.create !== 'function') return;

  event.preventDefault();

  const input = form.querySelector('input[type="email"]');
  const button = form.querySelector('button[type="submit"]');
  const status = form.querySelector('[data-sc-back-in-stock-status]');
  if (!input || !button || !status) return;

  button.disabled = true;

  window.BIS.create(input.value.trim(), Number(form.dataset.variantId), Number(form.dataset.productId), {
    accepts_marketing: false,
  }).then((response) => {
    if (response?.status === 'OK') {
      status.hidden = false;
      form.replaceChildren(status);
      return;
    }

    const message = Object.values(response?.errors ?? {}).flat().join(' ');
    input.setCustomValidity(message || input.validationMessage || 'Please check your email address.');
    input.reportValidity();
    input.addEventListener('input', () => input.setCustomValidity(''), { once: true });
    button.disabled = false;
  });
});
